import { render, staticRenderFns } from "./transferForm.vue?vue&type=template&id=50cd0336"
import script from "./transferForm.vue?vue&type=script&lang=js"
export * from "./transferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports